import React, { useMemo } from "react";
import './style.scss';
import ArrowCircleRightOutlinedIcon from '@mui/icons-material/ArrowCircleRightOutlined';
import EachAccount from "components/EachAccount";
import { formatAmount, mapCurrencies } from "../../../../lib/utils";
import { Link } from "react-router-dom";
import { useProfileQuery } from "pages/Authentication/queries";
import { useCurrenciesQuery } from "default/queries";

export function Accounts() {
	const { data: user } = useProfileQuery();
	const { data: currencies } = useCurrenciesQuery();

	const currencyMap = useMemo(() => mapCurrencies(currencies), [currencies]);
	const userWallets = user?.wallets || [];

	const walletDisplayCount = 2;
	const walletsToDisplay = userWallets.slice(0, walletDisplayCount);
	const showViewAll = userWallets.length > walletDisplayCount;

	return (
		<div className="account_side">
			<div className="cover_first_text">
				<p className="first_text">YOUR ACCOUNTS</p>
			</div>

			<div className="account_flex">
				{walletsToDisplay.map((wallet) => {
					const currObj = currencyMap[wallet.currency];
					return (
						<EachAccount
							key={wallet.id}
							currency={currObj.name}
							flag={currObj.flag}
							amount={formatAmount(wallet.balance, wallet.currency)}
						/>
					);
				})}
				{showViewAll ? (
					<Link to="/dashboard/bank" className="create_box">
						<p>View all</p>
						<ArrowCircleRightOutlinedIcon />
					</Link>
				) : (
					<Link to="/bank/create_account" className="create_box">
						<p>+ Create Account</p>
					</Link>
				)}
			</div>
		</div>
	);
}
